import React, { useState, useEffect } from 'react';
import { Task, getTimeUntilReset, formatTimeRemaining } from '@/utils/storage';

interface TaskCountdownProps {
  task: Task;
  onTaskReset?: (task: Task) => void;
}

const TaskCountdown: React.FC<TaskCountdownProps> = ({ task, onTaskReset }) => {
  const [remainingMinutes, setRemainingMinutes] = useState<number>(0);

  useEffect(() => {
    const updateCountdown = () => {
      const minutes = getTimeUntilReset(task);
      setRemainingMinutes(minutes);
      
      // If the task is ready to reset and was previously completed, trigger reset
      if (minutes <= 0 && task.completed && onTaskReset) {
        onTaskReset(task);
      }
    };

    // Update immediately
    updateCountdown();

    // Set up interval to update every minute (60000ms)
    const interval = setInterval(updateCountdown, 60000);

    return () => clearInterval(interval);
  }, [task, onTaskReset]);

  // Don't show countdown for tasks without reset interval or that aren't completed
  if (!task.resetInterval || task.resetInterval <= 0 || !task.lastReset) {
    return null;
  }

  return (
    <p className="text-xs text-muted-foreground mt-1">
      Resets in {formatTimeRemaining(remainingMinutes)}
    </p>
  );
};

export default TaskCountdown;